import { Component, Input, OnInit } from '@angular/core';
import { CalibrationService } from 'src/app/Service/Calibration/Calibration.service';

@Component({
  selector: 'app-DataEntityLinearity',
  templateUrl: './DataEntityLinearity.component.html',
  styleUrls: ['./DataEntityLinearity.component.scss']
})
export class DataEntityLinearityComponent implements OnInit {
  @Input() inner_Calibration_Device_Id:number=0
  @Input() inner_Calibration_Display:boolean=false

  selected_Display:number=0

  constructor(
    private Calibration_Service: CalibrationService,
  ) { }

  ngOnInit() {
    if(this.inner_Calibration_Display)
      this.selected_Display=1
    else
      this.selected_Display=0
  }


  Set_DisplayLinearity() {
    this.Calibration_Service.DisplayLinearity(this.inner_Calibration_Device_Id,this.selected_Display).subscribe(
      data => {

      },
      (error) => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )
  }

}
